module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjciIHZpZXdCb3g9IjAgMCA2IDciPgogICAgPHBhdGggZmlsbD0iI2Q5NTM0ZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMy4xNzQgNi4zODVBLjIyMy4yMjMgMCAwIDEgMyA2LjQ3MWEuMjI0LjIyNCAwIDAgMS0uMTc0LS4wODZMLjA1NCAyLjkwOWEuMjUzLjI1MyAwIDAgMS0uMDMzLS4yNTcuMjI3LjIyNyAwIDAgMSAuMjA2LS4xMzloMS4zMDZWLjI0MWMwLS4xMzMuMTAyLS4yNDEuMjI3LS4yNDFoMi40OGMuMTI2IDAgLjIyOC4xMDguMjI4LjI0djIuMjczaDEuMzA1Yy4wODggMCAuMTY5LjA1NC4yMDYuMTM5YS4yNTIuMjUyIDAgMCAxLS4wMzMuMjU3TDMuMTc0IDYuMzg1eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down-market-price-change.svg
// module id = iK3i
// module chunks = 0